import clsx from 'clsx';
import { ProgressBarProps } from './index';

export const Progress = ({
  className,
  indeterminate,
  value,
}: ProgressBarProps) => {
  return (
    <div
      className={clsx(
        className,
        'relative w-full h-1 bg-[#89551a] overflow-hidden'
      )}
    >
      <div
        style={{ translate: `${(((value ?? 0) / 100) * 100).toFixed(0)}%` }}
        className={clsx('absolute -left-full bg-primary w-full h-full', {
          ['transition-all duration-300 ease-in-out']: value !== undefined,
          ['animate-infinite']: indeterminate && value === undefined,
        })}
      />
    </div>
  );
};
